import React from "react";
import { Toolbar, Typography } from "@mui/material";
import { makeStyles } from '@mui/styles';
import { Add } from "@mui/icons-material";
import EnhancedIconButton from "../enhanced/EnhancedIconButton";

function EnhancedTableToolbar(props) {
  const classes = useToolbarStyles();
  const { setOpenNew, label, addible, authority } = props;

  return (
    <Toolbar className={classes.root}>
      <Typography className={classes.title} variant="h6" id="tableTitle" component="div">
        {label}
      </Typography>
      <div className={addible ? "" : classes.dNone}>
        <EnhancedIconButton
          authority={authority}
          ariaLabel="add item"
          tooltip="Přidat"
          color="primary"
          Icon={Add}
          onClick={() => setOpenNew(true)}
        />
      </div>
    </Toolbar>
  );
}

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1)
  },
  title: {
    flex: "1 1 100%"
  },
  dNone: {
    display: "none"
  }
}));

export default EnhancedTableToolbar;
